import { Field, Form, Formik } from 'formik';
import { TFunction } from 'i18next';
import React from 'react';
import { Password } from '~/Components/Icons';
import { changePasswordValidationScheme } from '~/Helpers/Validators.helper';
import { TextField, Divider, FormHelperText } from '~/UIKit';
import { IChangePassword } from '..';

export interface ChangePasswordProps {
  changePasswordInitialValues: IChangePassword;
  onValidateChangePassword: (data: IChangePassword) => void;
  classes: any;
  t: TFunction;
}

export const ChangePassword = ({
  changePasswordInitialValues,
  onValidateChangePassword,
  classes,
  t,
}: ChangePasswordProps) => (
  <Formik
    onSubmit={() => {}}
    initialValues={changePasswordInitialValues}
    validate={onValidateChangePassword}
    validationSchema={() => changePasswordValidationScheme(t)}
  >
    {({ errors, touched }) => (
      <Form>
        <Divider />
        <Field
          className={classes.textField}
          component={TextField}
          icon={<Password />}
          id="old_password"
          label={`${t('app.user.changePassword.old')} *`}
          name="old_password"
          placeholder={`${t('app.user.changePassword.old')} *`}
          inputProps={{ autoComplete: 'off' }}
          type="password"
          newDesign
          error={touched.old_password && Boolean(errors.old_password)}
          helperText={touched.old_password && errors.old_password}
        />
        <Divider />
        <FormHelperText data-testid="emailError">
          {touched.old_password && errors.old_password}
        </FormHelperText>
        <Field
          className={classes.textField}
          component={TextField}
          icon={<Password />}
          id="password"
          label={`${t('app.user.changePassword.new')} *`}
          name="password"
          inputProps={{ autoComplete: 'off' }}
          placeholder={`${t('app.user.changePassword.new')} *`}
          type="password"
          newDesign
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && errors.password}
        />
        <Divider />
        <FormHelperText data-testid="emailError">
          {touched.password && errors.password}
        </FormHelperText>
        <Field
          className={classes.textField}
          component={TextField}
          icon={<Password />}
          id="password_confirmation"
          label={`${t('app.user.changePassword.confirm')} *`}
          name="password_confirmation"
          inputProps={{ autoComplete: 'off' }}
          placeholder={`${t('app.user.changePassword.confirm')} *`}
          type="password"
          newDesign
          error={touched.password_confirmation && Boolean(errors.password_confirmation)}
          helperText={touched.password_confirmation && errors.password_confirmation}
        />
        <Divider />
        <FormHelperText data-testid="emailError">
          {touched.password_confirmation && errors.password_confirmation}
        </FormHelperText>
      </Form>
    )}
  </Formik>
);
